import { Box, Paper, Stack, Skeleton, CircularProgress } from '@mui/material';

/**
 * Skeletons over spinners wherever the shape of the result is known: a skeleton
 * says "a table is coming" and keeps the layout from jumping, where a centred
 * spinner says only "wait".
 */

export const PageLoader = () => (
  <Box sx={{ display: 'grid', placeItems: 'center', minHeight: 240 }}>
    <CircularProgress size={28} />
  </Box>
);

export const CardsSkeleton = ({ count = 4, height = 120 }) => (
  <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: `repeat(${count}, 1fr)` } }}>
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} variant="rounded" height={height} />
    ))}
  </Box>
);

export const ListSkeleton = ({ rows = 5, height = 52 }) => (
  <Paper sx={{ p: 2 }}>
    <Stack spacing={1.5}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={height} />
      ))}
    </Stack>
  </Paper>
);

export const DetailSkeleton = () => (
  <Stack spacing={2}>
    <Skeleton variant="rounded" height={96} />
    <Skeleton variant="rounded" height={220} />
    <Skeleton variant="rounded" height={160} />
  </Stack>
);
